/**
 * Variant short-description switcher.
 *
 * Reads variant_id -> short_description from the JSON in
 *   <script id="variant-short-descriptions" type="application/json">
 * and updates #short-description when the customer changes the selected
 * variant via swatches, the variant select, or any custom theme event.
 *
 * Originally lived inline in assets/theme.js (Alukas vendor file).
 * Extracted 2026-05-09 so theme updates don't overwrite it.
 *
 * Loaded only on product templates (see snippets/scripts-tag.liquid).
 */
(function () {
  'use strict';

  const DEBUG =
    window.location.hostname.endsWith('.myshopify.com') ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  function log() {
    if (DEBUG) console.log.apply(console, ['[ShortDesc]'].concat([].slice.call(arguments)));
  }
  function warn() {
    if (DEBUG) console.warn.apply(console, ['[ShortDesc]'].concat([].slice.call(arguments)));
  }
  function err() {
    if (DEBUG) console.error.apply(console, ['[ShortDesc]'].concat([].slice.call(arguments)));
  }

  document.addEventListener('DOMContentLoaded', function () {
    const shortEl = document.getElementById('short-description');
    if (!shortEl) {
      // Not on a product page (or theme didn't render the element). Nothing to do.
      return;
    }

    let shortMap = {};
    try {
      const mapScript = document.getElementById('variant-short-descriptions');
      if (mapScript) {
        shortMap = JSON.parse(mapScript.textContent || '{}');
        log('Map loaded:', shortMap);
      } else {
        warn('Map script not found');
      }
    } catch (e) {
      err('Failed to parse map JSON', e);
    }

    function getCurrentVariantId() {
      const input =
        document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        document.querySelector('input[name="id"]');
      const vid = input && input.value ? String(input.value) : null;
      log('Current variant id:', vid, ' (disabled:', input && input.disabled, ')');
      return vid;
    }

    function updateFromCurrentVariant() {
      const vid = getCurrentVariantId();
      if (!vid) {
        warn('No variant id found');
        return;
      }
      const desc = shortMap[vid];
      if (desc && desc.length) {
        shortEl.innerHTML = desc;
        log('Updated:', desc);
      } else {
        shortEl.innerHTML = 'No description available for this variant.';
        log('No desc mapped for', vid);
      }
    }

    // Scope listeners to the product page container when possible (perf + isolation).
    const productScope =
      document.querySelector('.bls__product-detail') ||
      document.querySelector('main') ||
      document.body;

    productScope.addEventListener('click', function (e) {
      const swatch = e.target.closest('.bls__option-swatch');
      if (swatch) {
        log('Swatch clicked:', swatch.getAttribute('data-value'));
        // Give the theme a tick to update the hidden input, then read it.
        setTimeout(updateFromCurrentVariant, 0);
      }
    });

    productScope.addEventListener('change', function (e) {
      if (e.target.matches('select[name="id"]')) {
        log('Variant dropdown changed:', e.target.value);
        updateFromCurrentVariant();
      }
    });

    document.addEventListener('variant:change', function (e) {
      log('variant:change event', e.detail);
      updateFromCurrentVariant();
    });
    document.addEventListener('product:variant-change', function (e) {
      log('product:variant-change event', e.detail);
      updateFromCurrentVariant();
    });

    updateFromCurrentVariant();
  });
})();
